/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State

==========================================================================================*/

export default {
  leads: [],
  leadsCount: 0,
  chats: [],
}
